<template>
  <div id="app">
    <Widget/>
    <Main/>
    <Letters data-aos="fade-up" />
    <BlockA id="block-a"/>
    <BlockB id="block-b"/>
    <div class="bg-red">
        <BlockV />
        <BlockG id="block-g" data-aos="fade-up"/>
        <BlockL id="block-l"/>
    </div>
    <div class="bg-black">
        <BlockN id="block-n" class="desktop" />
        <BlockNm class="mobile" />
        <BlockM id="block-m" class="desktop" />
        <BlockMm class="mobile" />
        <BlockR class="desktop" id="block-r"/>
        <BlockRm class="mobile" />
        <BlockT id="block-t" class="desktop" />
        <BlockTm class="mobile" />
    </div>
    <div class="bg-white">
        <BlockF class="desktop" id="block-f"/>
        <BlockFm class="mobile" />
        <BlockCH class="desktop" id="block-ch"/>
        <BlockCHm class="mobile" />
        <BlockSH class="desktop" id="block-sh"/>
        <BlockSHm class="mobile" />
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Main from './components/Main.vue'
import Widget from './components/Widget.vue'
import Letters from './components/Letters.vue'
import BlockA from './components/BlockA.vue'
import BlockB from './components/BlockB.vue'
import BlockV from './components/BlockV.vue'
import BlockG from './components/BlockG.vue'
import BlockL from './components/BlockL.vue'
import BlockN from './components/BlockN.vue'
import BlockNm from './components/BlockNm.vue'
import BlockM from './components/BlockM.vue'
import BlockMm from './components/BlockMm.vue'
import BlockRm from './components/BlockRm.vue'
import BlockR from './components/BlockR.vue'
import BlockT from './components/BlockT.vue'
import BlockTm from './components/BlockTm.vue'
import BlockF from './components/BlockF.vue'
import BlockFm from './components/BlockFm.vue'
import BlockCH from './components/BlockCH.vue'
import BlockCHm from './components/BlockCHm.vue'
import BlockSH from './components/BlockSH.vue'
import BlockSHm from './components/BlockSHm.vue'
import Bottom from './components/Bottom.vue'
import simpleParallax from 'simple-parallax-js';
import AOS from 'aos';
import 'aos/dist/aos.css';

export default {
  name: 'App',
  components: {
    Main,
    Widget,
    Letters,
    BlockA,
    BlockB,
    BlockV,
    BlockG,
    BlockF,
    BlockFm,
    BlockCH,
    BlockCHm,
    BlockL,
    BlockN,
    BlockM,
    BlockMm,
    BlockR,
    BlockRm,
    BlockT,
    BlockTm,
    BlockSH,
    BlockSHm,
    BlockNm,
    Bottom,
  },
  mounted() {
    var image = document.getElementsByClassName('js-parallax-1');
    new simpleParallax(image, {
        scale: 1.2,
        orientation: 'right'
    });
    AOS.init({
        duration: 800,
        delay: 300
    });
  }
}
</script>

<style>
article,aside,details,figcaption,figure,footer,header,hgroup,hr,menu,nav,section{display:block}a,hr{padding:0}abbr,address,article,aside,audio,b,blockquote,body,canvas,caption,cite,code,dd,del,details,dfn,div,dl,dt,em,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,p,pre,q,samp,section,small,span,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,ul,var,video{margin:0;padding:0;border:0;outline:0;font-size:100%;vertical-align:baseline;background:0 0}ins,mark{background-color:#ff9;color:#000}body{line-height:1}nav ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:'';content:none}a{margin:0;font-size:100%;vertical-align:baseline;background:0 0}ins{text-decoration:none}mark{font-style:italic;font-weight:700}del{text-decoration:line-through}abbr[title],dfn[title]{border-bottom:1px dotted;cursor:help}table{border-collapse:collapse;border-spacing:0}hr{height:1px;border:0;border-top:1px solid #ccc;margin:1em 0}input,select{vertical-align:middle}
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
body {
  font-family: Tautz;
  font-weight: 300;
  color: #fff;
}

#app {
    position: relative;
    overflow: hidden;
}

@font-face {
    font-family: 'Aphrosine';
    src: url('fonts/subset-Aphrosine-Light.woff2') format('woff2'),
        url('fonts/subset-Aphrosine-Light.woff') format('woff');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
}

@font-face {
    font-family: 'Gotham Pro';
    src: url('fonts/subset-GothamPro.woff2') format('woff2'),
        url('fonts/subset-GothamPro.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Tautz';
    src: url('fonts/subset-Tautz-Regular.woff2') format('woff2'),
        url('fonts/subset-Tautz-Regular.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}
@font-face {
    font-family: 'Tautz';
    src: url('fonts/subset-Tautz-Light.woff2') format('woff2'),
        url('fonts/subset-Tautz-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}


@font-face {
    font-family: 'Denistina';
    src: url('fonts/subset-Denistina.woff2') format('woff2'),
        url('fonts/subset-Denistina.woff') format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'ZnikomitNo25';
    src: url('fonts/subset-ZnikomitNo25.woff2') format('woff2'),
        url('fonts/subset-ZnikomitNo25.woff') format('woff');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
}

.bg-white {
    background-color: #fff;
}



</style>
